// extracted by mini-css-extract-plugin
export var content = "_qg-1";
export var fullScreen = "_qg-0";